<template>
  <div
    v-if="!redirects"
    class="share">
    <img
      v-if="hasValidLogo"
      :src="logo"
      alt="Logo"
      class="logo">
    <template v-if="!hasValidParams">
      <h1>
        <span v-t="'share.invalidParams'" />
      </h1>
    </template>
    <template v-else-if="submitted && error">
      <h1>
        <span v-t="'share.error'" />
      </h1>
    </template>
    <template v-else>
      <h1>
        <span v-t="'share.title'" />
        <span> {{ accountName }}</span>.
      </h1>
      <p
        v-t="'share.legend'"
        class="text-soft" />
      <div class="buttons">
        <button
          v-for="app in apps"
          :key="app.id"
          :style="[{ backgroundColor: app.color }, app.style]"
          @click="share(app)">
          {{ app.name }}
        </button>
      </div>
      <p class="text-soft">
        {{ $t('share.copyPaste') }}
        <a
          v-t="'share.thisLink'"
          :href="url" />.
      </p>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import parseDecode from '@/helpers/parseDecode';
import hasLogo from '@/mixins/hasLogo';

const apps = [
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    link: 'https://api.whatsapp.com/send?text=',
    hasTextParam: true,
    color: '#32D16B',
  },
  {
    id: 'facebook',
    name: 'Facebook',
    link: 'https://www.facebook.com/sharer/sharer.php?u=',
    hasTextParam: false,
    color: '#3b5998',
  },
  {
    id: 'twitter',
    name: 'Twitter',
    link: 'https://twitter.com/intent/tweet?text=',
    hasTextParam: true,
    color: '#1CAEEA',
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/shareArticle?url=',
    hasTextParam: false,
    color: '#1877A7',
  },
  {
    id: 'native',
    name: 'Elegir otra app',
    hasTextParam: false,
    color: '#FFFFFF',
    style: { border: '1px solid #1CAEEA', color: '#1CAEEA' },
  },
];

export default {
  mixins: [hasLogo],
  data() {
    return {
      error: null,
      submitted: false,
      account: null,
      accountName: null,
      url: null,
      text: null,
      apiUrl: null,
      redirects: true,
      nativeShare: false,
    };
  },
  computed: {
    hasValidParams() {
      return (this.account && this.accountName && this.url && this.apiUrl);
    },
    packet() {
      return this.$route.query.p;
    },
    apps() {
      return apps.filter((item) => {
        if (item.id === 'native') return navigator.share;
        return true;
      });
    },
  },
  created() {
    document.title = this.$t('share.pageTitle');
    this.parseParams();
    const immediateShare = this.$route.query.s;
    if (immediateShare) {
      this.share(this.apps.find((app) => app.id === immediateShare));
    } else {
      this.redirects = false;
      this.nativeShare = navigator.share;
      this.preloadLogo();
    }
  },
  methods: {
    parseParams() {
      const params = parseDecode(this.$route.query.d);
      if (!params) return false;
      this.account = params.a;
      this.accountName = params.n;
      this.url = params.s;
      this.text = params.t;
      this.apiUrl = params.u;
      return true;
    },
    async share(app) {
      const apiUrl = this.apiUrl.replace('{packet}', this.packet).replace('{app}', app.id);
      this.submitted = true;

      if (app.id === 'native') {
        return navigator.share({
          title: this.text,
          url: this.url,
        });
      }

      try {
        await axios.post(apiUrl);
        const url = this.shareable(app);
        window.location.href = url;
      } catch (error) {
        this.error = true;
      }

      return true;
    },
    shareable(app) {
      return app.hasTextParam ? [app.link, [this.text, this.url].join(' ')].join('') : [app.link, this.url].join('');
    },
  },
};
</script>
